type WidgetMode = 'iframe' | 'standalone';

const WIDGET_MODE_PATTERN = /\/-\/[^/]+\/(iframe|s)(?:\/|$|\?)/;

const getWidgetMode = (
  pathname: string = window.location.pathname,
): WidgetMode => {
  const match = pathname.match(WIDGET_MODE_PATTERN);
  return match?.[1] === 'iframe' ? 'iframe' : 'standalone';
};

export default getWidgetMode;
